import React, { useContext, useEffect, useState } from "react";
import { AddSizeChartContext } from "../../../Context/AddSizeChartContext";
import FormHeaderSection from "./FormHeaderSection";
import { getDefaultFormObjectByCategory } from "../SizeChartFormsData";
import FormInputSection from "./FormInputSection";
import SizeNameInput from "./SizeNameInput";

function SizesForm() {
    const { sizeChartFormData, selectedCategory, setSizeChartFormData } = useContext(AddSizeChartContext);
    const [categoryKeys, setCategoryKeys] = useState([]);

    const formatHeaderTitle = (text) => {
        if (!text) return "";
        return text
            .replace(/([A-Z])/g, " $1")
            .replace(/^./, (s) => s.toUpperCase())
            .trim();
    };

    const handleInputChange = (id, field, unit = null, value) => {
        const updatedData = sizeChartFormData.map((item) => {
            if (item.id === id) {
                if (unit) {
                    return {
                        ...item,
                        [field]: { ...item[field], [unit]: value }
                    };
                } else {
                    return { ...item, [field]: value };
                }
            }
            return item;
        });

        setSizeChartFormData(updatedData);
    };

    useEffect(() => {
        if (sizeChartFormData.length === 0) return;

        const defaultObj = getDefaultFormObjectByCategory(selectedCategory);
        const defaultKeys = Object.keys(defaultObj).filter((k) => k !== "id");
        const currentKeys = Object.keys(sizeChartFormData[0]).filter((k) => k !== "id");

        // Show only keys that actually exist in visible form
        const visibleKeys = currentKeys.filter((key) => sizeChartFormData.some(row => key in row));

        // Ensure consistent order: sizeName always first
        const finalKeys = visibleKeys.includes("sizeName")
            ? ["sizeName", ...visibleKeys.filter((k) => k !== "sizeName")]
            : visibleKeys;

        setCategoryKeys(finalKeys);
    }, [selectedCategory, sizeChartFormData]);

    return (
        <div className="w-fit border border-[#EAEAEA] rounded-lg">
            <div
                className={`w-fit flex items-center text-[16px] leading-[22px] text-[#121212] font-normal ${
                    sizeChartFormData.length > 0 && "border-b border-[#EAEAEA]"
                }`}
            >
                {categoryKeys.map((key, index) => {
                    const isLast = index === categoryKeys.length - 1;

                    if (key === "sizeName") {
                        return (
                            <div
                                key={key}
                                className={`w-[180px] h-[94px] px-6 py-3 flex items-center justify-center ${
                                    !isLast && "border-r border-[#EAEAEA]"
                                }`}
                            >
                                <p>Sizes</p>
                            </div>
                        );
                    }

                    return (
                        <FormHeaderSection
                            key={key}
                            isLast={isLast}
                            title={
                                (selectedCategory === "Shoe & Sandals" || selectedCategory === "High Heels")
                                    ? sizeChartFormData[0]?.[key]?.sizeName || formatHeaderTitle(key)
                                    : formatHeaderTitle(key)
                            }
                        />
                    );
                })}
            </div>

            {sizeChartFormData.length > 0 && (
                <>
                    {sizeChartFormData.map((row, rowIndex) => {
                        const isLastRow = rowIndex === sizeChartFormData.length - 1;

                        return (
                            <div
                                key={row.id}
                                className={`w-full flex items-center ${
                                    !isLastRow && "border-b border-[#EAEAEA]"
                                } text-[16px] leading-[22px] font-normal text-[#121212]`}
                            >
                                {categoryKeys.map((key, keyIndex) => {
                                    const isLastColumn = keyIndex === categoryKeys.length - 1;

                                    if (key === "sizeName") {
                                        return (
                                            <React.Fragment key={`${row.id}-${key}`}>
                                                {selectedCategory === "Trousers, Phants, Jeans" ? (
                                                    <div className="w-[180px] px-6 py-3 border-r border-[#EAEAEA]">
                                                        <input
                                                            type="text"
                                                            name="sizeName"
                                                            value={row.sizeName}
                                                            onChange={(e) =>
                                                                handleInputChange(
                                                                    row.id,
                                                                    "sizeName",
                                                                    null,
                                                                    e.target.value
                                                                )
                                                            }
                                                            placeholder="input"
                                                            className="w-full outline-none placeholder:text-center text-center"
                                                        />
                                                    </div>
                                                ) : (
                                                    <SizeNameInput isLast={isLastColumn} row={row} />
                                                )}
                                            </React.Fragment>
                                        );
                                    }

                                    return (
                                        <FormInputSection
                                            key={`${row.id}-${key}`}
                                            row_id={row.id}
                                            spec={key}
                                            isLast={isLastColumn}
                                            centimeters={row[key]?.cm || ""}
                                            inches={row[key]?.in || ""}
                                        />
                                    );
                                })}
                            </div>
                        );
                    })}
                </>
            )}
        </div>
    );
}

export default SizesForm;
